import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const RegistrierungenServiceConfig = {
  name: "Registrierungen",
  annotations: []
} as ServiceConfig;